// Mock Data - EMS Express Miroiterie Serrurerie
// Optimisé SEO pour VITRY-SUR-SEINE
// STRUCTURE AVEC SOUS-SERVICES
import { clientConfig } from '../config/client.config';

export const companyInfo = {
  ...clientConfig.company,
};

// SERVICES PRINCIPAUX AVEC SOUS-SERVICES
export const services = [
  {
    id: "vitrerie",
    title: "Vitrerie - Miroiterie",
    shortDesc: "Remplacement vitrage, miroirs sur mesure, vitrines commerciales à Vitry-sur-Seine",
    description: "Expert en vitrerie et miroiterie à Vitry-sur-Seine et dans tout le Val-de-Marne (94). Remplacement de vitres cassées, installation de double vitrage, miroirs sur mesure, vitrines commerciales. Intervention rapide pour bris de glace.",
    icon: "glass",
    seoKeywords: ["vitrier vitry", "vitrier vitry-sur-seine", "bris de glace vitry", "miroiterie vitry"],
    subServices: [
      {
        id: "remplacement-vitrage-simple",
        title: "Remplacement Vitrage Simple",
        shortDesc: "Remplacement rapide de vitrage simple à Vitry-sur-Seine",
        description: "Spécialiste du remplacement de vitrage simple à Vitry-sur-Seine (94). Intervention rapide pour fenêtres, portes vitrées, cloisons. Devis gratuit et transparent.",
        features: ["Fenêtres anciennes", "Portes vitrées", "Cloisons vitrées", "Impostes", "Intervention rapide", "Devis gratuit"],
        seoKeywords: ["remplacement vitrage vitry", "vitrage simple vitry", "changer vitre vitry"]
      },
      {
        id: "double-vitrage",
        title: "Double Vitrage",
        shortDesc: "Installation et remplacement de double vitrage à Vitry-sur-Seine",
        description: "Expert en double vitrage à Vitry-sur-Seine. Installation neuve ou remplacement de double vitrage pour améliorer l'isolation thermique et phonique de votre logement. Intervention sur tout le Val-de-Marne.",
        features: ["Double vitrage standard", "Double vitrage renforcé", "Vitrage isolant", "Amélioration thermique", "Isolation phonique", "Économies d'énergie"],
        seoKeywords: ["double vitrage vitry", "installation double vitrage vitry", "vitrage isolant vitry"]
      },
      {
        id: "vitrines-commerciales",
        title: "Vitrines Commerciales",
        shortDesc: "Installation et réparation de vitrines de magasin à Vitry-sur-Seine",
        description: "Installation, remplacement et réparation de vitrines commerciales à Vitry-sur-Seine. Sécurisation après effraction, vitrage anti-effraction, vitrines sur mesure pour commerces.",
        features: ["Vitrines de magasin", "Vitrage sécurit", "Anti-effraction", "Sur mesure", "Réparation urgente", "Devantures"],
        seoKeywords: ["vitrine commerciale vitry", "vitrine magasin vitry", "réparation vitrine vitry"]
      },
      {
        id: "bris-de-glace",
        title: "Bris de Glace Urgence",
        shortDesc: "Intervention urgente bris de glace 24h/24 à Vitry-sur-Seine",
        description: "Service d'urgence bris de glace disponible 24h/24 à Vitry-sur-Seine. Intervention rapide en 30 minutes pour sécuriser et remplacer vos vitres cassées. Attestation pour assurance.",
        features: ["Urgence 24h/24", "Intervention 30 min", "Sécurisation immédiate", "Attestation assurance", "Remplacement rapide", "Tous types de vitres"],
        seoKeywords: ["bris de glace vitry", "urgence vitre cassée vitry", "vitrier urgence vitry 24h"]
      },
      {
        id: "miroirs-sur-mesure",
        title: "Miroirs sur Mesure",
        shortDesc: "Création et pose de miroirs sur mesure à Vitry-sur-Seine",
        description: "Fabrication et installation de miroirs sur mesure à Vitry-sur-Seine. Miroirs décoratifs, miroirs de salle de bain, grands miroirs, découpe personnalisée. Pose professionnelle.",
        features: ["Découpe sur mesure", "Miroirs décoratifs", "Salle de bain", "Grands formats", "Pose incluse", "Finitions soignées"],
        seoKeywords: ["miroir sur mesure vitry", "miroitier vitry", "pose miroir vitry"]
      },
      {
        id: "credences-verre",
        title: "Crédences en Verre",
        shortDesc: "Installation de crédences en verre pour cuisine à Vitry-sur-Seine",
        description: "Pose de crédences en verre laqué pour cuisine à Vitry-sur-Seine. Protection murale élégante et facile d'entretien. Large choix de coloris, découpe sur mesure.",
        features: ["Verre laqué", "Sur mesure", "Nombreux coloris", "Cuisine", "Salle de bain", "Pose professionnelle"],
        seoKeywords: ["crédence verre vitry", "crédence cuisine vitry", "verre laqué vitry"]
      }
    ]
  },
  {
    id: "serrurerie",
    title: "Serrurerie",
    shortDesc: "Ouverture de porte, changement serrure, installation blindée à Vitry-sur-Seine",
    description: "Serrurier professionnel disponible 24h/24 à Vitry-sur-Seine et environs. Ouverture de porte claquée ou fermée, remplacement de serrure, installation porte blindée, reproduction de clés.",
    icon: "key",
    seoKeywords: ["serrurier vitry", "serrurier vitry-sur-seine", "ouverture porte vitry", "serrure vitry"],
    subServices: [
      {
        id: "ouverture-porte",
        title: "Ouverture de Porte",
        shortDesc: "Ouverture de porte claquée ou fermée à Vitry-sur-Seine",
        description: "Service d'ouverture de porte disponible 24h/24 à Vitry-sur-Seine. Porte claquée, clés perdues, serrure bloquée. Intervention rapide sans dégât, techniques non destructives.",
        features: ["Porte claquée", "Clés perdues", "Serrure bloquée", "Sans dégât", "24h/24", "Intervention rapide"],
        seoKeywords: ["ouverture porte vitry", "porte claquée vitry", "serrurier ouverture vitry"]
      },
      {
        id: "changement-serrure",
        title: "Changement de Serrure",
        shortDesc: "Remplacement de serrure tous types à Vitry-sur-Seine",
        description: "Changement et remplacement de serrure à Vitry-sur-Seine. Serrures multipoints, cylindres européens, serrures haute sécurité. Installation professionnelle, toutes marques.",
        features: ["Serrure multipoints", "Cylindre européen", "Haute sécurité", "Toutes marques", "A2P", "Garantie"],
        seoKeywords: ["changement serrure vitry", "remplacement serrure vitry", "serrure multipoints vitry"]
      },
      {
        id: "porte-blindee",
        title: "Porte Blindée",
        shortDesc: "Installation et réparation de porte blindée à Vitry-sur-Seine",
        description: "Spécialiste de la porte blindée à Vitry-sur-Seine. Installation de blocs-portes blindés, blindage de porte existante, serrures haute sécurité A2P. Protection optimale contre les effractions.",
        features: ["Bloc-porte blindé", "Blindage sur existant", "Serrure A2P", "Anti-effraction", "Isolation", "Certification"],
        seoKeywords: ["porte blindée vitry", "blindage porte vitry", "installation porte blindée vitry"]
      },
      {
        id: "cylindre-europeen",
        title: "Cylindre Européen",
        shortDesc: "Remplacement de cylindre européen à Vitry-sur-Seine",
        description: "Remplacement de cylindre européen à Vitry-sur-Seine. Cylindres haute sécurité, anti-crochetage, anti-perçage. Marques reconnues : Vachette, Bricard, Mul-T-Lock.",
        features: ["Anti-crochetage", "Anti-perçage", "Anti-casse", "Haute sécurité", "Grandes marques", "Installation rapide"],
        seoKeywords: ["cylindre européen vitry", "barillet serrure vitry", "cylindre haute sécurité vitry"]
      },
      {
        id: "reproduction-cles",
        title: "Reproduction de Clés",
        shortDesc: "Reproduction et copie de clés à Vitry-sur-Seine",
        description: "Service de reproduction de clés à Vitry-sur-Seine. Clés plates, clés sécurisées, clés de voiture, badges d'immeuble. Copie rapide et précise.",
        features: ["Clés plates", "Clés sécurisées", "Clés voiture", "Badges", "Copie rapide", "Toutes marques"],
        seoKeywords: ["reproduction clés vitry", "copie clé vitry", "double clé vitry"]
      },
      {
        id: "serrure-haute-securite",
        title: "Serrure Haute Sécurité",
        shortDesc: "Installation de serrures certifiées A2P à Vitry-sur-Seine",
        description: "Installation de serrures haute sécurité certifiées A2P à Vitry-sur-Seine. Protection maximale contre les effractions, serrures 3 points, 5 points, 7 points.",
        features: ["Certification A2P", "3, 5, 7 points", "Anti-effraction", "Assurance", "Grandes marques", "Garantie"],
        seoKeywords: ["serrure haute sécurité vitry", "serrure A2P vitry", "serrure certifiée vitry"]
      }
    ]
  },
  {
    id: "menuiserie",
    title: "Menuiserie",
    shortDesc: "Portes, fenêtres, cadres, menuiseries intérieures et extérieures",
    description: "Menuisier qualifié pour l'installation et la réparation de portes, fenêtres, cadres et menuiseries à Vitry-sur-Seine. Travail soigné sur bois, PVC et aluminium.",
    icon: "door",
    seoKeywords: ["menuisier vitry", "pose fenêtres vitry", "porte intérieure vitry", "menuiserie vitry"],
    subServices: [
      {
        id: "portes-interieures",
        title: "Portes Intérieures",
        shortDesc: "Installation et remplacement de portes intérieures à Vitry-sur-Seine",
        description: "Pose et remplacement de portes intérieures à Vitry-sur-Seine. Portes pleines, vitrées, coulissantes, sur pivot. Bois, MDF, stratifié. Finitions soignées.",
        features: ["Portes pleines", "Portes vitrées", "Portes coulissantes", "Portes sur pivot", "Bois et MDF", "Pose incluse"],
        seoKeywords: ["porte intérieure vitry", "pose porte vitry", "remplacement porte vitry"]
      },
      {
        id: "fenetres-pvc",
        title: "Fenêtres PVC",
        shortDesc: "Installation de fenêtres PVC à Vitry-sur-Seine",
        description: "Spécialiste des fenêtres PVC à Vitry-sur-Seine. Installation, remplacement, rénovation. Excellent rapport qualité-prix, isolation thermique et phonique optimale.",
        features: ["Double vitrage", "Isolation thermique", "Isolation phonique", "Oscillo-battant", "Sur mesure", "Garantie 10 ans"],
        seoKeywords: ["fenêtre PVC vitry", "pose fenêtre PVC vitry", "fenêtre double vitrage vitry"]
      },
      {
        id: "fenetres-aluminium",
        title: "Fenêtres Aluminium",
        shortDesc: "Installation de fenêtres aluminium à Vitry-sur-Seine",
        description: "Fenêtres aluminium haut de gamme à Vitry-sur-Seine. Design moderne, profilés fins, grande luminosité. Idéal pour les grandes ouvertures et baies vitrées.",
        features: ["Profilés fins", "Grande luminosité", "Design moderne", "Baies vitrées", "Couleurs RAL", "Rupture de pont thermique"],
        seoKeywords: ["fenêtre aluminium vitry", "fenêtre alu vitry", "baie vitrée alu vitry"]
      },
      {
        id: "fenetres-bois",
        title: "Fenêtres Bois",
        shortDesc: "Installation de fenêtres bois traditionnelles à Vitry-sur-Seine",
        description: "Fenêtres bois traditionnelles et modernes à Vitry-sur-Seine. Charme authentique, excellente isolation naturelle. Rénovation de fenêtres anciennes.",
        features: ["Bois massif", "Charme authentique", "Isolation naturelle", "Rénovation ancien", "Sur mesure", "Lasure/Peinture"],
        seoKeywords: ["fenêtre bois vitry", "menuiserie bois vitry", "fenêtre traditionnelle vitry"]
      },
      {
        id: "porte-fenetre",
        title: "Porte-Fenêtre",
        shortDesc: "Installation de portes-fenêtres à Vitry-sur-Seine",
        description: "Pose de portes-fenêtres PVC, aluminium et bois à Vitry-sur-Seine. Accès terrasse et balcon, grande luminosité, sécurité renforcée. Sur mesure.",
        features: ["PVC, Alu, Bois", "Accès terrasse", "Grande luminosité", "Sécurité renforcée", "Sur mesure", "Volet roulant intégré"],
        seoKeywords: ["porte-fenêtre vitry", "porte fenêtre vitry", "baie vitrée vitry"]
      },
      {
        id: "volets-persiennes",
        title: "Volets et Persiennes",
        shortDesc: "Installation de volets battants et roulants à Vitry-sur-Seine",
        description: "Pose de volets et persiennes à Vitry-sur-Seine. Volets battants, volets roulants manuels ou motorisés, persiennes. PVC, aluminium, bois.",
        features: ["Volets battants", "Volets roulants", "Motorisation", "Persiennes", "PVC/Alu/Bois", "Réparation"],
        seoKeywords: ["volet vitry", "volet roulant vitry", "persienne vitry"]
      },
      {
        id: "cadres-huisseries",
        title: "Cadres et Huisseries",
        shortDesc: "Réparation et remplacement de cadres et huisseries à Vitry-sur-Seine",
        description: "Réparation et remplacement de cadres et huisseries à Vitry-sur-Seine. Dormants abîmés, huisseries pourries, mise aux normes. Travail soigné.",
        features: ["Remplacement dormant", "Réparation huisserie", "Mise aux normes", "Bois/PVC/Alu", "Étanchéité", "Isolation"],
        seoKeywords: ["huisserie vitry", "cadre fenêtre vitry", "dormant fenêtre vitry"]
      }
    ]
  },
  {
    id: "urgence",
    title: "Dépannage Urgence 24h/24",
    shortDesc: "Intervention rapide jour et nuit, 7j/7, en 30 minutes à Vitry-sur-Seine",
    description: "Service d'urgence disponible 24h/24 et 7j/7. Intervention en moins de 30 minutes sur Vitry-sur-Seine et communes environnantes pour vitrerie, serrurerie et sécurisation.",
    icon: "clock",
    seoKeywords: ["urgence vitrier vitry", "serrurier 24h vitry", "dépannage nuit vitry"],
    subServices: [
      {
        id: "urgence-vitrerie",
        title: "Urgence Vitrerie",
        shortDesc: "Vitrier d'urgence 24h/24 à Vitry-sur-Seine",
        description: "Service de vitrerie d'urgence disponible 24h/24 à Vitry-sur-Seine. Vitre cassée, bris de glace, sécurisation après effraction. Intervention en 30 minutes.",
        features: ["24h/24 - 7j/7", "30 min d'intervention", "Vitre cassée", "Bris de glace", "Sécurisation", "Attestation assurance"],
        seoKeywords: ["vitrier urgence vitry", "vitre cassée urgence vitry", "vitrier nuit vitry"]
      },
      {
        id: "urgence-serrurerie",
        title: "Urgence Serrurerie",
        shortDesc: "Serrurier d'urgence 24h/24 à Vitry-sur-Seine",
        description: "Serrurier d'urgence disponible 24h/24 à Vitry-sur-Seine. Porte claquée, clés perdues, serrure cassée, effraction. Intervention rapide et professionnelle.",
        features: ["24h/24 - 7j/7", "Porte claquée", "Clés perdues", "Serrure cassée", "Après effraction", "Sans dégât"],
        seoKeywords: ["serrurier urgence vitry", "serrurier nuit vitry", "porte claquée urgence vitry"]
      },
      {
        id: "depannage-week-end",
        title: "Dépannage Week-end et Jours Fériés",
        shortDesc: "Intervention week-end et jours fériés à Vitry-sur-Seine",
        description: "Service de dépannage disponible les week-ends et jours fériés à Vitry-sur-Seine. Vitrerie et serrurerie sans supplément excessif.",
        features: ["Samedi", "Dimanche", "Jours fériés", "Tarifs honnêtes", "Intervention rapide", "Devis gratuit"],
        seoKeywords: ["dépannage week-end vitry", "serrurier dimanche vitry", "vitrier samedi vitry"]
      }
    ]
  },
  {
    id: "securisation",
    title: "Sécurisation Provisoire",
    shortDesc: "Protection après effraction, cambriolage ou sinistre à Vitry-sur-Seine",
    description: "Sécurisation immédiate de votre logement après effraction, tentative de cambriolage ou sinistre. Pose de panneaux provisoires, blindage temporaire, protection des ouvertures.",
    icon: "shield",
    seoKeywords: ["sécurisation effraction vitry", "protection cambriolage vitry"],
    subServices: [
      {
        id: "securisation-effraction",
        title: "Sécurisation Après Effraction",
        shortDesc: "Protection immédiate après cambriolage à Vitry-sur-Seine",
        description: "Service de sécurisation d'urgence après effraction à Vitry-sur-Seine. Protection immédiate de votre logement ou commerce, remplacement des ouvertures endommagées.",
        features: ["Intervention immédiate", "Panneaux provisoires", "Remplacement serrure", "Vitre cassée", "Attestation assurance", "24h/24"],
        seoKeywords: ["sécurisation effraction vitry", "après cambriolage vitry", "protection urgente vitry"]
      },
      {
        id: "blindage-temporaire",
        title: "Blindage Temporaire",
        shortDesc: "Blindage provisoire de porte à Vitry-sur-Seine",
        description: "Installation de blindage temporaire à Vitry-sur-Seine. Solution provisoire en attendant le remplacement définitif. Sécurisation efficace et rapide.",
        features: ["Protection immédiate", "Porte endommagée", "En attente travaux", "Efficace", "Rapide", "Économique"],
        seoKeywords: ["blindage temporaire vitry", "protection provisoire vitry", "sécurisation porte vitry"]
      }
    ]
  },
  {
    id: "maintenance",
    title: "Maintenance & Prévention",
    shortDesc: "Entretien régulier, contrats maintenance, prévention",
    description: "Service de maintenance préventive pour particuliers et professionnels à Vitry-sur-Seine. Entretien des fermetures, contrôle des serrures, vérification des vitrages.",
    icon: "wrench",
    seoKeywords: ["maintenance serrurerie vitry", "entretien vitrerie vitry"],
    subServices: [
      {
        id: "contrat-maintenance",
        title: "Contrat de Maintenance",
        shortDesc: "Contrats de maintenance pour copropriétés et commerces à Vitry-sur-Seine",
        description: "Contrats de maintenance sur mesure pour copropriétés, commerces et entreprises à Vitry-sur-Seine. Entretien préventif, interventions prioritaires, tarifs préférentiels.",
        features: ["Copropriétés", "Commerces", "Entreprises", "Tarifs préférentiels", "Intervention prioritaire", "Rapport annuel"],
        seoKeywords: ["contrat maintenance vitry", "entretien copropriété vitry", "maintenance commerce vitry"]
      },
      {
        id: "entretien-preventif",
        title: "Entretien Préventif",
        shortDesc: "Vérification et entretien de vos fermetures à Vitry-sur-Seine",
        description: "Service d'entretien préventif à Vitry-sur-Seine. Vérification et graissage des serrures, contrôle des joints, réglage des fenêtres. Évitez les pannes.",
        features: ["Vérification serrures", "Graissage", "Contrôle joints", "Réglage fenêtres", "Rapport d'intervention", "Conseils"],
        seoKeywords: ["entretien préventif vitry", "vérification serrure vitry", "réglage fenêtre vitry"]
      }
    ]
  }
];

// VITRY-SUR-SEINE EN PREMIER (PRIORITÉ SEO)
export const cities = clientConfig.cities;

export const testimonials = [
  {
    id: 1,
    name: "Jean D.",
    city: "Vitry-sur-Seine",
    rating: 5,
    text: "Intervention ultra rapide à Vitry ! Vitre cassée remplacée en 30 minutes. Technicien professionnel et prix très correct. Je recommande vivement EMS Express !",
    service: "Vitrerie",
    date: "2025-01"
  },
  {
    id: 2,
    name: "Marie S.",
    city: "Vitry-sur-Seine",
    rating: 5,
    text: "Serrurier de confiance sur Vitry-sur-Seine. Porte ouverte en 15 minutes sans casser la serrure. Dépannage d'urgence efficace, disponible même le dimanche !",
    service: "Serrurerie",
    date: "2025-02"
  },
  {
    id: 3,
    name: "Pierre L.",
    city: "Créteil",
    rating: 5,
    text: "Excellent travail de miroiterie, devis transparent. Miroir sur mesure parfaitement installé. Très satisfait du résultat et du professionnalisme.",
    service: "Miroiterie",
    date: "2024-12"
  },
  {
    id: 4,
    name: "Sophie M.",
    city: "Vitry-sur-Seine",
    rating: 5,
    text: "Suite à une effraction à Vitry, EMS est intervenu à 23h pour sécuriser mon appartement. Réactivité exceptionnelle, local protégé rapidement. Merci !",
    service: "Urgence",
    date: "2025-01"
  }
];

export const advantages = [
  {
    id: 1,
    title: "20+ ans d'expérience",
    description: "Artisans qualifiés avec plus de 20 ans de métier",
    icon: "award"
  },
  {
    id: 2,
    title: "Intervention rapide",
    description: "Sur place en 30 minutes à Vitry-sur-Seine et environs",
    icon: "zap"
  },
  {
    id: 3,
    title: "Devis gratuit",
    description: "Estimation claire et transparente avant intervention",
    icon: "file-text"
  },
  {
    id: 4,
    title: "Garantie satisfaction",
    description: "Travail soigné avec garantie sur toutes nos prestations",
    icon: "check-circle"
  }
];

export const formOptions = {
  requestTypes: [
    { value: "urgence", label: "Urgence (intervention rapide)" },
    { value: "programme", label: "Intervention programmée" },
    { value: "devis", label: "Demande de devis" }
  ],
  serviceTypes: [
    { value: "vitrerie", label: "Vitrerie - Miroiterie" },
    { value: "serrurerie", label: "Serrurerie" },
    { value: "menuiserie", label: "Menuiserie" },
    { value: "securisation", label: "Sécurisation" },
    { value: "maintenance", label: "Maintenance" },
    { value: "autre", label: "Autre" }
  ],
  housingTypes: [
    { value: "appartement", label: "Appartement" },
    { value: "maison", label: "Maison" },
    { value: "commerce", label: "Commerce / Local professionnel" },
    { value: "copropriete", label: "Parties communes copropriété" },
    { value: "autre", label: "Autre" }
  ],
  accessTypes: [
    { value: "facile", label: "Accès facile (RDC, ascenseur)" },
    { value: "escalier", label: "Escalier sans ascenseur" },
    { value: "difficile", label: "Accès difficile (étage élevé, échafaudage)" },
    { value: "exterieur", label: "Intervention extérieure" }
  ]
};

// Helper function to get all sub-services flat
export const getAllSubServices = () => {
  const allSubs = [];
  services.forEach(service => {
    if (service.subServices) {
      service.subServices.forEach(sub => {
        allSubs.push({
          ...sub,
          parentId: service.id,
          parentTitle: service.title
        });
      });
    }
  });
  return allSubs;
};

// Helper function to get sub-service by ID
export const getSubServiceById = (serviceId, subServiceId) => {
  const service = services.find(s => s.id === serviceId);
  if (!service || !service.subServices) return null;
  return service.subServices.find(sub => sub.id === subServiceId);
};

export default {
  companyInfo,
  services,
  cities,
  testimonials,
  advantages,
  formOptions,
  getAllSubServices,
  getSubServiceById
};